import { ThemeProvider, createTheme } from "@mui/material/styles";
import { PaletteColor, PaletteColorOptions } from "@mui/material";

// Extending PaletteColorOptions and PaletteColor to include medium
const theme = createTheme({
  palette: {
    primary: {
      light: "#09A0F2",
      main: "#09A0F2",
      dark: "#09A0F2",
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
    },
    liteColor: {
      foreColor: {
        light: "#09A0F2",
        main: "#09A0F2",
        dark: "#0444aa",
        medium: "", // Optional, if needed
        tableHeader: "", // Optional, if needed
        tableRowAdd: "", // Optional, if needed
        tableRowEven: "", // Optional, if needed
        disabled: "#BABCC0", // Optional, if needed
        hover: "#ffff00",
        error: "#f25309",
      },
      backColor: {
        main: "#F0F2F5", // 主要な背景色
        light: "#FFF", // 明るいバリエーション
        medium: "#dcdcdc",
        dark: "#202226", // 暗いバリエーション
        tableHeader: "#4B4B4B",
        tableRowAdd: "#F0F2F5",
        tableRowEven: "#dcdcdc",
        disabled: "#a1a1a1",
      },
    },
    darkColor: {
      foreColor: {
        light: "#7ADBFF",
        main: "#7ADBFF",
        dark: "#09A0F2",
        medium: "", // Optional, if needed
        tableHeader: "", // Optional, if needed
        tableRowAdd: "", // Optional, if needed
        tableRowEven: "", // Optional, if needed
        disabled: "#BABCC0", // Optional, if needed
        hover: "#ffff00",
        error: "#f25309",
      },
      backColor: {
        main: "#2F3137", // 主要な背景色
        light: "#37393F", // 明るいバリエーション
        dark: "#202226", // 暗いバリエーション
        tableHeader: "#202226",
        tableRowAdd: "##37393F",
        tableRowEven: "#2F3137",
        disabled: "#a1a1a1",
      },
    },
  },
});

export { theme };
